import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { FsessionService } from 'src/app/servicios/session/fsession.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[IsAllowed]',
  standalone: false,
})
export class IsAllowedDirective {
  private fse = inject(FsessionService);
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  @Input() set IsAllowed(condition) {
    if (this.fse.optenerValor('dato43')[condition] !== '1') {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
